import React, { useState, useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config.js';
import { DialogContentText } from '@mui/material';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function DeleteUserDialog(props) {

    const auth = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const { notificationSuccess, notificationError } = useNotification();

    const deleteUser = async() => {
        if(loading === true)return;
        try {
            setLoading(true);
        
            if(!props.lastCellData.sub)return;

            const data = {
                userSub: props.lastCellData.sub
            }

            const axiosParams = {
                url: '/delete-user',
                method: 'post',
                baseURL: config.API_URL,
                headers: {
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Utente Eliminato', '', 5000);

            await props.getUsers();
            props.handleCloseDeleteUserDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage, '', 10000);
                } else {
                    notificationError('Oops, an error has occured', '', 10000);
                }
            }
            setLoading(false);
        }
    }

    return (
        <Dialog className="dialog-delete-user" open={props.openDeleteUserDialog} onClose={props.handleCloseDeleteUserDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Elimina Utente</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Vuoi eliminare l'utente {props?.lastCellData?.nome|| ''}{props?.lastCellData?.cognome|| ''}?
                </DialogContentText>
                <DialogContentText>L'azione è irreversibile.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={deleteUser}>
                    Elimina
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseDeleteUserDialog}>
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteUserDialog